import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Tippy from "@tippyjs/react/headless";
import { ThemeContext } from "../Theme";

import styles from "./Tooltip.scss";

export const Tooltip = ({ children, content, contentProps, ...restProps }) => {
  const [fadeIn, setFadeIn] = useState(false);
  let theme = "";
  theme = useContext(ThemeContext);
  const tooltipClasses = classNames(styles.tooltip, styles[theme], {
    [styles["fade-in"]]: fadeIn,
  });

  return (
    <div className={styles[theme]} {...restProps}>
      <Tippy
        onMount={() => setFadeIn(true)}
        onUntrigger={() => setFadeIn(false)}
        delay={[0, 300]}
        render={(attrs) => (
          <div
            className={tooltipClasses}
            tabIndex="-1"
            {...attrs}
            {...contentProps}
          >
            {content}
            <span className={styles.arrow} data-popper-arrow />
          </div>
        )}
      >
        <span
          className={styles["text-decoration"]}
          data-tooltip="true"
          role="button"
          tabIndex="0"
        >
          {children}
        </span>
      </Tippy>
    </div>
  );
};

Tooltip.displayName = "Tooltip";

Tooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string.isRequired,
  ]).isRequired,
  contentProps: PropTypes.shape({}),
};

Tooltip.defaultProps = {
  contentProps: {},
};

export default Tooltip;
